import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import Modal from 'components/v2/Modal'
import { Button } from 'components/v2/Button'
import { device } from 'utils/style'
import { ReactElement } from 'react'

export const Title = styled.p<TSFixMe>`
  font-size: 18px;
  line-height: 1.2;
  text-align: center;
  color: #1d3e72;
  margin-top: 20px;
  margin-bottom: 10px;

  @media ${device.laptop} {
    font-size: 28px;
    line-height: 1.32;
    margin-top: 30px;
    margin-bottom: 30px;
  }
`

export const DescriptionWrapper = styled.div<TSFixMe>`
  margin-top: 20px;
  margin-bottom: 10px;

  @media ${device.laptop} {
    margin-top: 10px;
    margin-bottom: 20px;
  }
`

export const Description = styled.p<TSFixMe>`
  font-size: 14px;
  line-height: 1.1;
  text-align: center;
  color: #1d3e72;
  margin-top: 10px;
  margin-bottom: 10px;

  @media ${device.laptop} {
    font-size: 18px;
    line-height: 1.28;
  }
`

export const TimerIsUpModal = (): ReactElement => {
  const handleClose = (): void => {
    window.location.reload()
  }

  return (
    <Modal.Container>
      <Modal.Content>
        <Title>
          <FormattedMessage id="bookings.edit.timeisup.title" defaultMessage="¡Time is up!" />
        </Title>

        <DescriptionWrapper>
          <Description>
            <FormattedMessage
              id="bookings.edit.timeisup.desc1"
              defaultMessage="Your time to confirm the new trips is over."
            />
          </Description>

          <Description>
            <FormattedMessage id="bookings.edit.timeisup.desc2" defaultMessage="You need to select your trips again." />
          </Description>
        </DescriptionWrapper>
      </Modal.Content>

      <Modal.Footer>
        <Modal.Actions>
          <Button kind="primary" onClick={handleClose}>
            <FormattedMessage id="bookings.edit.timeisup.action" defaultMessage="Start over" />
          </Button>
        </Modal.Actions>
      </Modal.Footer>
    </Modal.Container>
  )
}
